import type { ReactNode } from 'react';
import clsx from 'clsx';

type Color = 'blue' | 'green' | 'orange' | 'purple' | 'red';

const accent: Record<Color, string> = {
  blue: 'before:bg-blue',
  green: 'before:bg-green',
  orange: 'before:bg-orange',
  purple: 'before:bg-purple',
  red: 'before:bg-red',
};

const iconBg: Record<Color, string> = {
  blue: 'bg-blue/15 text-blue-light',
  green: 'bg-green/15 text-green',
  orange: 'bg-orange/15 text-orange',
  purple: 'bg-purple/15 text-purple',
  red: 'bg-red/15 text-red',
};

export function KpiCard({
  label, value, delta, deltaPositive = true, icon, color = 'blue',
}: {
  label: string;
  value: ReactNode;
  delta?: string;
  deltaPositive?: boolean;
  icon?: ReactNode;
  color?: Color;
}) {
  return (
    <div
      className={clsx(
        'card relative overflow-hidden',
        'before:absolute before:top-0 before:left-0 before:right-0 before:h-[3px]',
        accent[color],
      )}
    >
      {icon && (
        <div className={clsx('absolute top-3 right-3 w-9 h-9 rounded-[10px] flex items-center justify-center', iconBg[color])}>
          {icon}
        </div>
      )}
      <div className="text-xs uppercase tracking-wide text-muted font-medium mb-2">{label}</div>
      <div className="text-3xl font-extrabold leading-none">{value}</div>
      {delta && (
        <div className={clsx('text-[11px] mt-2 font-semibold', deltaPositive ? 'text-green' : 'text-red')}>
          {delta}
        </div>
      )}
    </div>
  );
}
